import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { ifProp } from 'styled-tools';

import { Button } from 'src/components/button';
import { media } from 'src/components/base';
import { layout } from 'src/components/base/styles/variables';

type BannerProps = {
  $themeColor?: string;
  logo?: string;
  $inverted: boolean;
};

export const Banner = styled(({ $themeColor, logo, $inverted, ...rest }) => (
  <Link {...rest} />
))<BannerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: ${layout.measurements.spacing050};
  padding-bottom: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  margin-top: ${layout.measurements.spacing050};
  border-radius: 5px;
  font-weight: 600;

  background-color: ${props => props.$themeColor || 'transparent'};
  color: #fff;

  ${media.mediumDown`
    justify-content: end;
    padding-top: ${layout.measurements.spacing025};
    padding-bottom: ${layout.measurements.spacing025};
  `}

  ${ifProp(
    'logo',
    css<BannerProps>`
      padding-left: 120px;
      background-image: url(${props => props.logo});
      background-size: 100px;
      background-position-y: 50%;
      background-position-x: 20px;
      background-repeat: no-repeat;
    `
  )};

  ${ifProp(
    '$inverted',
    css<BannerProps>`
      border: 2px solid
        ${props => props.$themeColor || props.theme.lines.primary};
      background-color: ${props => props.theme.bg.primary};
      color: ${props => props.$themeColor || props.theme.text.primary};
    `
  )};
`;

type TextProps = {
  $themeColor?: string;
  $inverted: boolean;
};

export const Text = styled.span<TextProps>`
  margin: 0 auto 0 ${layout.measurements.spacing100};
  color: ${props => (props.$inverted ? props.$themeColor : '#fff')};
  font-size: ${layout.measurements.fontSizeSmall};
  ${media.mediumUp`
    font-size: ${layout.measurements.fontSizeNormal};
  `}
`;

type CampaignLinkProps = {
  $themeColor?: string;
  $inverted: boolean;
};

export const CampaignLink = styled(({ themeColor, logo, ...rest }) => (
  <Button {...rest} />
)).attrs({
  color: 'primary',
  variant: 'text',
})<CampaignLinkProps>`
  /* Double selector needed to override hover color */
  && {
    color: ${props => (props.$inverted ? props.$themeColor : '#fff')};
  }
`;

export const LinkText = styled.span`
  ${media.mediumDown`
    display: none;
  `};
`;
